import useSWR from 'swr';
import api from '../../config/configApi';

const getToken = () => localStorage.getItem('token'); // ajuste a chave se for outra

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.beneficios ?? [];
  } catch (err) {
    console.error('Erro ao buscar origens:', err?.response?.status, err?.message);
    return [];
  }
};

export default function useBeneficioConfiguracoes() {
  const {
    data: beneficios = [], error, isLoading, mutate,
  } = useSWR(
    '/beneficio/config/beneficios',
    fetcher,
  );

  const criarBeneficio = async (payload) => {
    try {
      const token = getToken();
      await api.post('/beneficio/config/beneficios', payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para criar beneficio.');
      }
      throw err;
    }
  };

  const editarBeneficio = async (id, payload) => {
    try {
      await api.put(`/beneficio/config/beneficios/${id}`, payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para editar beneficio.');
      }
      throw err;
    }
  };

  return {
    beneficios,
    isLoading,
    isError: !!error,
    criarBeneficio,
    editarBeneficio,
    refetch: mutate,
  };
}
